export default {
    locationLoading: false,
    locationsListLoading: false,
    locationsList: [],
}